
  Vue.component('fall-into-oblivion', {
    props: {
      userId: { type: String }
    },
    data() {
      return {
        visible: true
      }
    },
    template: '#fall-into-oblivion',
    computed: {
      required() {
        return true
      }
    },
    watch: {},
    methods: {
      handleSomething() {
        const self = this
        return false
      },
      handleDelete() {
        EventBus.$emit('vnPopup', {
          style: 'popup',
          message: `
             <p>Vuoi procedere con la cancellazione del tuo account LearK?</p>
             <p class="h5 weight-300">La cancellazione comporta la perdita di tutti i dati associati al tuo account, inclusi i dati di accesso e le informazioni personali che non saranno recuperabili. Per rendere il tuo profilo visibile solo a te e non perdere i dati associati al tuo account, seleziona la voce “privato” nella sezione “Preferenze privacy”.</p>
          `,
          actions: [
            { label: 'OK', icon: 'fa-check-circle', action: () => this.deleteCandidate(), style: 'success' },
            { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
          ]
        })
      },
      deleteCandidate() {
        const self = this
        axios
          .post(`/api/v1/users/delete-candidate`)
          .then(response => {
            const { redirect } = response.data
            EventBus.$emit('vnPopup', {
              style: 'popup',
              type: 'success',
              message: `La cancellazione è stata effettuata correttamente. `,
              actions: [
                {
                  label: 'OK',
                  icon: 'fa-check-circle',
                  action: () => (window.location.href = redirect),
                  style: 'success'
                }
              ]
            })
          })
          .catch(error => {
            EventBus.$emit('vnPopup', {
              type: 'danger',
              message: `Non è stato possibile completare l'operazione.`
            })
          })
          .then(() => {
            // always executed
          })
      }
    },
    mounted() {},
    beforeDestroy() {}
  })
